import React, { PureComponent } from 'react';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table,Modal
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import EyeIcon from 'mdi-react/EyeIcon';
import EmailIcon from 'mdi-react/EmailIcon';
import AccountSearchIcon from 'mdi-react/AccountSearchIcon';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import renderFileInputField from '../../../../shared/components/form/FileInput';
import renderSelectField from '../../../../shared/components/form/Select';
import renderMultiSelectField from '../../../../shared/components/form/MultiSelect';
import $ from 'jquery';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import Util from '../../../Common/util';
import API from '../../../Common/api';
import axios from "axios";
import Select from 'react-select';
import { MDBDataTable } from 'mdbreact';
import './styles.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

var url = window.location.hostname;
var port = window.location.port;





const options = [
  { value: 'chocolate', label: 'Chocolate' },
  { value: 'strawberry', label: 'Strawberry' },
  { value: 'vanilla', label: 'Vanilla' },
];

const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xlsx';
	  
 const exportToMultiWBCSV = (csvData, fileName) => { 
 
	let today_date = new Date();
	let date = today_date.getDate();
	let month = today_date.getMonth() + 1;
	let year = today_date.getFullYear();
	let hour = today_date.getHours();
	let minutes = today_date.getMinutes();
	
	
	if(parseInt(minutes.toString().length) == 1){
		minutes= "0" + minutes.toString();
	}
	
	if(parseInt(month.toString().length) == 1){
		month= "0" + month.toString();
	}
	
	let today = year+"-"+month+"-"+date+"_"+hour+minutes;
	fileName = fileName+"_"+today;
	
	
	var wb = {SheetNames:[], Sheets:{}};
	var increment = 1;
	for(let i = 0; i < csvData.length;i++){
		const ws = XLSX.utils.aoa_to_sheet(csvData[i]);
		ws['!merges'] = [];
		
		
		if(increment == 1){
			var sheetname = "PRD";
		}else if(increment == 2){
			var sheetname = "PRD + MRP";
		}else if(increment == 3){
			var sheetname = "PRD + MRP + PKD";
		}
		
		wb.SheetNames.push(sheetname); 
		wb.Sheets[sheetname] = ws;
		
		if(i == 0){
			var merge = XLSX.utils.decode_range("A1:C1");
			var merge2 = XLSX.utils.decode_range("D1:H1");
			var merge3 = XLSX.utils.decode_range("I1:L1");
			
		}else if(i ==1){
			var merge = XLSX.utils.decode_range("A1:D1");
			var merge2 = XLSX.utils.decode_range("E1:J1");
			var merge3 = XLSX.utils.decode_range("K1:O1");
		}else if(i == 2){
			
			
			var merge = XLSX.utils.decode_range("A1:E1");
			var merge2 = XLSX.utils.decode_range("F1:K1");
			var merge3 = XLSX.utils.decode_range("L1:P1");
			
		}
		ws['!merges'].push(merge);
		ws['!merges'].push(merge2);
		ws['!merges'].push(merge3);
		
		increment++;
	}

	const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
	const data = new Blob([excelBuffer], {type: fileType});
	FileSaver.saveAs(data, fileName + fileExtension);
  }
  
 const exportToCSV = (csvData, fileName,header) => {
    // const ws = XLSX.utils.json_to_sheet(csvData);
    const Heading = [header]
    const ws = XLSX.utils.json_to_sheet(csvData,{ origin: 'A2', skipHeader: true });
    XLSX.utils.sheet_add_aoa(ws, Heading, { origin: 'A1' });
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], {type: fileType});
    FileSaver.saveAs(data, fileName + fileExtension);
  }

 function formatDate(date) {
    var d = new Date(date),
     month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  


  constructor() {
   super();
   this.handleChange = this.handleChange.bind(this);
   /*this.handleFile = this.handleFile.bind(this);*/
   this.change = this.change.bind(this);
   this.createCookie = this.createCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
   this.fetchBinData = this.fetchBinData.bind(this);
   this.fetchCustomerInventoryVsWms = this.fetchCustomerInventoryVsWms.bind(this);
   this.toggle = this.toggle.bind(this);
   this.toggleFailed = this.toggleFailed.bind(this);
   this.indexOfExt = this.indexOfExt.bind(this);
   this.processData = this.processData.bind(this);
   this.togglePressCancel = this.togglePressCancel.bind(this);
   this.Successtoggle = this.Successtoggle.bind(this);
   this.SuccesstoggleCancel = this.SuccesstoggleCancel.bind(this);
   this.generateReport1 = this.generateReport1.bind(this);
   this.onBinChange = this.onBinChange.bind(this);
   this.uploadFile = this.uploadFile.bind(this);
   this.setFile = this.setFile.bind(this);

   /*this.onMasterChange = this.onMasterChange.bind(this);*/

    this.state = {
      showPassword: false,
      showGenerate: true,
      showUpload: false,
      showInputUpload: false,
	  showDateFilter: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      showInvalidBaseItem:false,
      showInvalidProductItem:false,
      fileNameVal: '',
      showResponseData: false,
      showBaseResponseData: false,
      showProductResponseData: false,
      showFetchTesterPick: false,
      showBinTesterInventory: false,
      showBinUtilization: false,
      postsBinInventory: [],
      showTesterInventory: false,
      responseUpdatedBaseData: false,
      responseUpdatedProductData: false,
      showCustomerInventoryVSWmsInventory: false,
      showLocationInput: false,
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      genloading: false,
      posts: [],
      postsBase: [],
      postsProduct: [],
      postsInventoryAlt: [],
      fileName: {},
      postsBinUtilization: [],
      postsZoneCorrection: [],
      postsProductLedger: [],
      tableProductLedger: [],
      postsCustomerVsWms: [],
      tableRowsCustomerVsWm: [],

      postsBinInventory: [],
      postsTesterInventory: [],
      postsBinTesterInventory: [],
      tableRowsBase: [],
      tableRowsProduct: [],
      tableInventoryAlt: [],
      tableBinInventory: [],
      tableTesterInventory: [],
      tableBinTesterInventory: [],
      tableBinUtilization: [],
      tableTesterPick: [],
      tableNonMoving: [],
      postsNonMoving: [],
      tableBinFragmentation: [],
      postsBinFragmentation: [],
      image_file: null,
      filtered_orderData : [],

      image_preview: '',
      ErrorRowData: [],
      product_inventory_header : ['Brand',	'Jarvis Product Id',	'Product Name',	'PKD',	'UPC', 'MRP',	'Product Code',	'Putaway Staging Qty',	'Receiving Staging',	'Available',	'Allocated',	'WH Damaged','WH Expired','MKT Damaged','MKT Expired','Short','Excess' ],
      locaton_wise_header : ['Client','Jarvis Product Id','Bin Status',	'Stock Type', 'Product Name',	'Basepack Code',	'PKD',	'UPC', 'MRP',	'CBU Code',	'SKU7Code',	'Bin Address','Zone Name',	'Quantity (pcs)',	'Pre Alloc Qty (pcs)', 'Putaway Alloc'],
      tester_inventory_header : ['Basepack Code',	'Bin Quantity',	'PTL Staging Qty(Pcs)',	'Putaway Staging Qty(Pcs)',	'Dispatch Staging',	'Z_Missing',	'Z Damaged',	'Z Excess',	'Z Return',	'Z Expiry',	'Shortage (Primary Pure)',	'Shortage (Primary Interchange)','Shortage Returns',	'Shortage Wh',	'Excess (Primary Pure)',	'Excess (Primary Interchange)'	,'Excess Returns'	,'Damaged Primary',	'Damaged LeanBox'],
      nonmoving_header : ['Base Pack',	'In Stock(days)',	'Days Since Last Order'],

      modal: false,
      modalFailed: false,
      Successmodal: false,
      loading: false,
      showinventoryaltData: false,
	  ledger_fromdate: "",
      ledger_todate: "",

      isLoading:true,
      showFetchBinData: false,
      showFetchBaseData: false,
      showFetchProductData: false,
      show_process_data: true,
	
      download_sample_excel:[{
			"Storage Bin":"",
			"Material Number":"",
			"Material Description":"",
			"Shelf Life Expiration Date":"",
			"Available stock":"",
			"Batch Case Config":"",
			"Total Quantity":"",
			"Batch Number":"",
			"Packing date":"",
			"Storage location":"",
			"Indicative Price":"",
			"Batch Case Qty":"",
			"Batch Eaches Qty":"",
			"Quantity to remove":"",
			"Gross Weight of mate":"",
			"Net Weight of materi":"",
			"Source Factory":"",
			"Stock Category":"",
			"Warehouse Number":"",
			"Batch UOM":"",
			"Plant":"",
			"Price lot Number":"",
			"Storage Type":"",
			"Stock for putaway":"",
			"Weight Unit":"",
			"SKU5 code":"",
			"Special Stock Indica":"",
			"Special Stock Number":"",
			"Storage Unit Number":"",
			"Inspection Lot Number":"",

		}],
		
		different_workbook : [
		[
			["","","","SAP","","","","","WMS","","",""],
			["cbuCode","Category", "Sub Category","Good", "Expired", "Damaged","Frozen", "SAP TTL", "Good", "Expired", "Damaged","WMS TTL"]
		],
		[
			["","","","","SAP","","","","","","WMS","","","","","",""],
			["cbuCode","MRP","Category", "Sub Category","Good", "Expired", "Damaged","Frozen", "SAP TTL", "MRP TTL","Good", "Expired", "Damaged","WMS TTL", "MRP TTL","Diff QTY TTL (WMS - SAP)","Diff Value (WMS - SAP)"]
		],
		[
			["","","","","","SAP","","","","","","WMS","","","","","",""],
			["cbuCode","MRP","PKD","Category", "Sub Category", "Good", "Expired", "Damaged","Frozen","SAP TTL", "MRP TTL","Good", "Expired", "Damaged", "WMS TTL", "MRP TTL","Diff QTY TTL (WMS - SAP)","Diff Value (WMS - SAP)"]
		]
		],
	
      tableRows: [],
      value: '',
      error: '',
      value: 'select',
      selectedFileType: '',
      BinMasters:["Aisle","Bin", "Bin Address" , "Level" , "Rack" , "Rack Type" , "Storage Type" , "Zone Name" , "Zone No."],
      /*BasePackCodes:["Base Pack Code" , "Zone Name" , "Zone No"],*/

      BasePackCodes:[{"Base Pack Code": "fghj" , "Zone Name": "fghj" , "Zone No": "fghj"}],

      validation: {
        "Bin Master": {
          "Aisle": "string",
          "Bin": "number",
          "Bin Address": "string",
          "Level": "number",
          "Rack": "number",
          "Rack type": "string",
          "Storage type": "string",
          "Zone Name": "string",
          "Zone No.": "number",
        },

        "Basepack Zone": {
          "Base Pack Code": "string",
          "Zone Name": "string",
          "Zone No.": "number",
        },

        "Product Master": {
          "Company": "string",
          "Brand": "number",
          "Sub Brand": "string",
          "LB SKU ID": "number",
          "LB SKU Product Name": "number",
          "Basepack Code": "string",
          "CBU Code": "string",
          "Shade Code": "string",
          "Shade Name": "number",
          "Category": "string",
          "Sub-Category": "string",
          "Price Lot": "string",
          "MRP": "string",
          "UOM": "string",
          "UPC": "string",
          "Pack Size": "string",
          "Pack Size UOM": "string",
          "EAN": "string",
          "ICLD EAN": "string",
          "Weight": "string",
          "Volume": "string",
          "ICLD Volume": "string",
          "SKU7 Code": "string",
          "SKU5 Code": "string",
          "Offer": "string",
          "Tester": "string",
          "Storage Type": "string",
          "Status": "string",
          "Created Date Time": "string",
          "Updated Date Time": "string",
        },
      },
     
    };

    this.createCookie();
    this.accessCookie();
  }


  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };

   onBinChange(value){
      this.setState({
        bin_address: value
      })

      localStorage.setItem('bin_address' , value)

  }

  setFile(e){

        let image_as_files = e.target.files[0];

        this.setState({
            image_file: image_as_files,
    })
  }




  exportToCSV1 = (csvData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], {type: fileType});
    FileSaver.saveAs(data, fileName + fileExtension);
  }


  uploadFile(){
    this.setState({
      genloading: true
    })
    if (this.state.image_file !== null){

      console.log(this.state.image_file)

      let formData = new FormData();
      formData.append('custFile', this.state.image_file);
      formData.append('location', this.state.selectedLocation);

      console.log(formData);

       const payload = {
        formData
  };

API.post('/reports/custInventoryUpload/', { param: payload })
        .then((response) =>  {

          console.log(response);
          if (response.data.status == true) {

            this.setState({
              uploadMessage: response.data.reason,
              genloading: false,
              modal: true,
              modalFailed: false
            })
          }else{

            this.setState({
              uploadMessage: response.data.reason,
              genloading: false,
              modal: false,
              modalFailed: true,
            })

          }
       
        })
        .catch(function (error) {
          
          
       

      })  
   
    }
  }


ledgerFromDateChange = date  => {
      this.setState({
        ledger_fromdate : date
      })  
  }

  ledgerToDateChange = date => {
      this.setState({
        ledger_todate :  date
      })  
  }


   


  componentWillMount(){

      if (window.location.port == 8091 || window.location.port === ":8090") {
          port = ":8090"
        }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    }else{
          port = ":8088"
        }

      if (url === "localhost") {
        //url= "3.215.84.36" + ":8088";
        url= "15.206.34.41" + ":8088";
      }else{
        url= window.location.hostname + port;
      }

      var cookieUsername = this.getCookie('token');
      var Location = this.getCookie('selectedLocation');
      var username = this.accessCookie("token");
      this.setState({
        userName: cookieUsername,
        selectedLocation: Location,
      })

      localStorage.setItem('userName' , username);
    }



   createCookie(cookieName,cookieValue,daysToExpire)
        {
          var date = new Date();
          date.setTime(date.getTime()+(1*24*60*60*1000));
          document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
        }

  accessCookie(cookieName)
        {
          var name = cookieName + "=";
          var allCookieArray = document.cookie.split(';');
          for(var i=0; i<allCookieArray.length; i++)
          {
            var temp = allCookieArray[i].trim();
            if (temp.indexOf(name)==0)
            return temp.substring(name.length,temp.length);
         }
        return "";
        } 


        getCookie(cname) {
          var name = cname + "=";
          var decodedCookie = decodeURIComponent(document.cookie);
          var ca = decodedCookie.split(';');
          for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
              c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
            }
          }
          return "";
        }

 

  /*onMasterChange(event){
    this.setState({
      value: event.target.value
    })
    console.log(this.state.value);

  }*/

  SuccesstoggleCancel(){
    this.setState({
        Successmodal: false
    })

    if (this.state.selectedOption.value === "bin_master") {
          this.fetchBinData();
          

      } else if (this.state.selectedOption.value === "base_pack_zone") {
          this.fetchBaseData();
          

      } else if (this.state.selectedOption.value === "product_master") {
          this.fetchProductData();
          

      }
  }

  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));

  }

  Successtoggle() {
    this.setState(prevState => ({ Successmodal: !prevState.Successmodal }));
  }

  toggleFailed() {
    this.setState(prevState => ({ modalFailed: !prevState.modalFailed }));

    
  }

  togglePressCancel(){


      this.setState({
        modal: false,
        modalFailed: false,
        image_file: null

      })

      

  }

  indexOfExt(list, item) {
    var len = list.length;

    for (var i = 0; i < len; i++) {
        var keys = Object.keys(list[i]);
        var flg = true;
        for (var j = 0; j < keys.length; j++) {
            var value = list[i][keys[j]];
            if (item[keys[j]] !== value) {
                flg = false;
            }
        }
        if (flg == true) {
            return i;
        }
    }
    return -1;
}

  fetchBinData(){


      this.setState({
        showFetchBinData: true,
        showFetchBaseData: false,
        showFetchProductData: false
      })


      axios.get('http://'+url+'/inventory/bin_master/v1/',
        {
             headers: {
                  'Content-Type': 'application/json',
                  'Authorization' : this.state.userName
                  
                } 

           }
      )

      .then(response => response.data)

      .then(data => {

         // console.log(data);

         // if (err) throw err;

         this.setState({ posts: data })

      })

      .then(async() => {

         this.setState({ tableRows:this.assemblePosts(), isLoading:false })

         console.log(this.state.tableRows);

      });
  }


  fetchBaseData(){


      this.setState({
        showFetchBaseData: true,
        showFetchBinData: false,
        showFetchProductData: false

      })


      axios.get('http://'+url+'/inventory/base_pack_zone_code_master/v1/',
        {
             headers: {
                  'Content-Type': 'application/json',
                  'Authorization' : this.state.userName
                  
                } 

           }
      )

      .then(response => response.data)

      .then(data => {

         // console.log(data);

         // if (err) throw err;

         this.setState({ postsBase: data })

      })

      .then(async() => {

         this.setState({ tableRowsBase:this.assemblePostsBase(), isLoading:false })

         console.log(this.state.tableRowsBase);

      });
  }

  fetchCustomerInventoryVsWms(){


      const payload = {
        location: this.state.selectedLocation,
  };

API.post('/reports/fetchCustWmsReportList/', { param: payload })

      .then(response => response.data)

      .then(data => {

         // console.log(data);

         // if (err) throw err;

         console.log(data);

         this.setState({ postsCustomerVsWms: data })

      })

      .then(async() => {

         this.setState({ tableRowsCustomerVsWm:this.assemblePostsCustomerVsWm(), isLoading:false })

         console.log(this.state.tableRowsCustomerVsWm);

      });
  }



  fetchProductData(){


      this.setState({
        showFetchBaseData: false,
        showFetchBinData: false,
        showFetchProductData: true,

      })


      axios.get('http://'+url+'/product/product_master/v1/',
        {
             headers: {
                  'Content-Type': 'application/json',
                  'Authorization' : this.state.userName
                  
                } 

           }
      )

      .then(response => response.data)

      .then(data => {

         // console.log(data);

         // if (err) throw err;

         this.setState({ postsProduct: data })
        

      })

      .then(async() => {

         this.setState({ tableRowsProduct:this.assemblePostsProduct(), isLoading:false })

         console.log(this.state.tableRowsProduct);

      });
  }



  assemblePosts= () => {
    let posts =this.state.posts.map((post) => {
      return ({
          bin: post.bin_address,
          zone_number: post.zone_no,
          zone_name: post.zone_code,
          warehouse: post.warehouse
        })
    });
    this.setState({
      posts : posts
    });
    return posts;

  }


   assemblePostsZoneCompliance= () => {

    let postsZoneCompliance =this.state.postsZoneCompliance.map((post) => {

      return (

        {

         

          Zone_No: post['Zone No.'],

          Zone_Name: post['Zone Name'],

          Bin_Count: post['Bin Count'],

          Bins_Occupied: post['Bins Occupied'],

          Bin_Occupied_by_Correct_Product: post['Bin Occupied by Correct Product'],

          Bin_Occupied_by_Product_with_Different_Zone: post['Bin Occupied by Product with Different Zone'],

          Bin_Unoccupied: post['Bin Unoccupied'],

          

        }

      )

    });
    this.setState({
      postsZoneCompliance : postsZoneCompliance,
    })

    return postsZoneCompliance;

  }


  assemblePostsNonMoving= () => {

    let postsNonMoving =this.state.postsNonMoving.map((post) => {

      return (

        {

         


          Base_Pack: post['Base Pack'],

          In_Stock: post['In Stock(days)'],

          Days_Since_Last_Order: post['Days Since Last Order']

        }

      )

    });
    this.setState({
      postsNonMoving : postsNonMoving,
    });
    return postsNonMoving;

  }

  assemblePostsBinFragmentation= () => {

    let postsBinFragmentation =this.state.postsBinFragmentation.map((post) => {

      return (

        {

         

          Product_ID: post['Product ID'],

          Product_Name: post['Product Name'],

          PKD:  post['PKD'],

          Total_QTY:  post['Total QTY'],

          Bin_MAX_QTY:  post['Bin MAX QTY'],

          Bin_Count:  post['Bin Count'],




        }

      )
      

    });
    this.setState({
      postsBinFragmentation : postsBinFragmentation,
    });
    return postsBinFragmentation;

  }





  assemblePostsBinUtilization= () => {

    let postsBinUtilization =this.state.postsBinUtilization.map((post) => {

      return (

        {

         

          zone_id: post.zone_id,
          zone_name: post['Zone Name'],

          Total: post.Total,

          Used: post.Used,

          Remaining: post.Remaining,
          BinUtilization: post['BinUtilization(%)'],
          SpaceAvailable: post['SpaceAvailable(%)']

        }

      )

    });
    this.setState({
      postsBinUtilization : postsBinUtilization,
    });

    return postsBinUtilization;

  }


  assemblePostsBase= () => {

    let postsBase =this.state.postsBase.map((post, index) => {

      return (

        {

          sl_no: index+1,

          ptl_id: post.ptl_id,

          cbu_code: post.cbu_code,

          batch: post.batch,

          lb_sku_id: post.lb_sku_id,

          lbSkuProductName: post.product_name,

          mrp: post.mrp,

          upc: post.upc,

          pkd: post.pkd,

          total_quantity: post.total_qty ,

          icld_quantity: post.icld_qty ,

          loose_quantity: post.loose_qty ,

          base_pack_code: post.base_pack_code,

          added_on : post.added_on_str

        }

      )

    });

    let postsBaseWithoutSNO =this.state.postsBase.map((post, index) => {

      return (

        {

          ptl_id: post.ptl_id,

          cbu_code: post.cbu_code,

          batch: post.batch,

          lb_sku_id: post.lb_sku_id,

          lbSkuProductName: post.product_name,

          mrp: post.mrp,

          upc: post.upc,

          pkd: post.pkd,

          total_quantity: post.total_qty ,

          icld_quantity: post.icld_qty ,

          loose_quantity: post.loose_qty ,

          base_pack_code: post.base_pack_code,

          added_on : post.added_on_str

        }

      )

    });

    this.setState({
      postsBase : postsBaseWithoutSNO,
    });
    return postsBase;

  }




  assemblePostsInventoryAlt= () => {

    let postsInventoryAlt =this.state.postsInventoryAlt.map((post, index) => {

      return (

        {

        

          lb_sku_id: post.lb_sku_id,

          bin_address: post.location,

          cbu_code: post.cbu_code,

          bin_qty: post.bin_qty,

          sku7_code: post.sku7_code,

          mrp: post.mrp,

          pkd: post.pkd,

          ean: post.ean,

          

        }

      )

    });

    this.setState({
      postsInventoryAlt : postsInventoryAlt,
    });
    return postsInventoryAlt;

  }


  assemblePostsBinInventory= () => {

    let postsBinInventory =this.state.postsBinInventory.map((post, index) => {

      return (

        {

        
          client: post.client,
          lb_sku_id: post.lb_sku_id,
          bin_status: post.bin_status,
          stock_type: post.stock_type,

          lbSkuProductName: post.lb_sku_product_name,

          base_pack: post.basepack_code,

          pkd: post.pkd,
          upc: post.upc,
		  
		      mrp: post.mrp,

          cbu_code: post.cbu_code,


          sku7_code: post.sku7_code,

          bin_address: post.Bin_ID,

          zone_name : post.zone_name,

          quantity: post.qty,

          pre_alloc_qty: post.pre_alloc_qty,
          putaway_alloc: post.putaway_alloc,

          

          

        }

      )

    });
    this.setState({
      postsBinInventory : postsBinInventory,
      filtered_orderData : postsBinInventory,
    });

    return postsBinInventory;

  }


  assemblePostsBinTesterInventory= () => {

    let postsBinTesterInventory =this.state.postsBinTesterInventory.map((post, index) => {

      return (

        {

        

          base_pack_code: post.base_pack,

          bin_address: post.Bin_ID,

          quantity: post.qty,

          pre_alloc_qty: post.pre_alloc_qty 


        }

      )

    });
    this.setState({
      postsBinTesterInventory : postsBinTesterInventory,
    });

    return postsBinTesterInventory;

  }


  assemblePostsLocationLedger= () => {

    let postsLocationLedger =this.state.postsLocationLedger.map((post, index) => {

      return (

        {

        

          status: post.status,

          from_pre_move_count: post.from_pre_move_count,

          from_area: post.from_area,

          to_area: post.to_area,
          from_post_move_count: post.from_post_move_count  


        }

      )

    });

    this.setState({
      postsLocationLedger : postsLocationLedger,
    });

    return postsLocationLedger;

  }



  assemblePostsProductLedger= () => {

    let postsProductLedger =this.state.postsProductLedger.map((post, index) => {

      return (

        {

        

          Operation_Date: post['Operation Date'],

          Operation: post.Operation,

          Operation_ID: post['Operation ID'],

          Basepack_Code: post['Basepack Code'],
          CBU_Code: post['CBU Code'] ,
          Product_ID: post['Product ID'] ,
          Product_Name: post['Product Name'] ,
           PKD: post['PKD'],
           QTY: post['QTY'],
           From_Area: post['From Area'],
          To_Area: post['To Area'],
            username: post.username,




        }

      )

    });

    this.setState({
      postsProductLedger : postsProductLedger,
    });
    return postsProductLedger;

  }



  assemblePostsTesterPick= () => {

    let postsTesterPick =this.state.postsTesterPick.map((post, index) => {

      return (

        {

        

          tester_order_number: post.tester_order_number,

          party_code: post.party_code,

          party_name: post.party_name,

          sales_beat: post.sales_beat,
          shade_code: post.shade_code,
          shade_name: post.shade_name,
          product_desc: post.product_desc,
          picking_request_id: post.picking_request_id,
          orderdate: post.orderdate,
          ptl_id: post.ptl_id,
          zone: post.zone,
          base_pack_code: post.base_pack_code,
          order_qty: post.order_qty,
          picked_qty: post.picked_qty,


        }

      )

    });

    this.setState({
      postsTesterPick : postsTesterPick,
    });

    return postsTesterPick;

  }


  assemblePostsTesterInventory= () => {

    let postsTesterInventory =this.state.postsTesterInventory.map((post, index) => {

      return (

        {

        

          product__base_pack_code: post.product__base_pack_code,

         // product__tester: post.product__tester,

          bin_qty: post.bin_qty,

          ptl_staging: post.ptl_staging,

          putaway_staging: post.putaway_staging,

          dispatch_staging: post.dispatch_staging,

          
          

          z_missing: post.z_missing,



          z_damaged: post.z_damaged ,

          z_excess: post.z_excess ,

          z_return: post.z_return ,

          z_expiry: post.z_expiry ,

          shortage_primary_pure: post.shortage_primary_pure,

          shortage_primary_interchange: post.shortage_primary_interchange,

          shortage_return: post.shortage_returns,

          shortage_wh: post.shortage_wh,

          excess_primary_pure: post.excess_primary_pure,

          excess_primary_interchange: post.excess_primary_interchange,

          excess_return: post.excess_returns,

          damaged_primary: post.damaged_primary,

          damaged_leanbox: post.damaged_leanbox,


        }

      )

    });
    this.setState({
      postsTesterInventory : postsTesterInventory,
    });


    return postsTesterInventory;

  }

  assemblePostsCustomerVsWm= () => {
    console.log(this.state.postsCustomerVsWms);

    let postsCustomerVsWms =this.state.postsCustomerVsWms.map((post) => {

      return (

        {

         

          
          file_name : post.fileName,

          status: post.status,

          status_completion: post.statusCompletion,
          download_excel: <span onClick={r => this.downloadExcel(post.id,post.fileName)}  class="lnr lnr-download" style={{color: '#0F52BA', fontSize: 22, fontWeight: 'bold'}}></span>



        }

      )

    });

    this.setState({
      postsCustomerVsWms : postsCustomerVsWms,
    });

    return postsCustomerVsWms;

  }



  downloadExcel(id,fileName){

    const payload = {
      location: this.state.selectedLocation,
      report_type: 9,
      id: id
  };

API.post('/reports/multiReport/v1/', { param: payload })

      .then(response => response.data)

      .then(data => {
		console.log(data);		
		 for(var i=0;i < 3;i++){
			var sheet_data = this.state.different_workbook;
			var sheetIndex = i;
			for(var j=0;j < data[i].length;j++){
				
				if(i == 0){
					var tmp_data = [
						data[i][j]["CBUCode"],
						data[i][j]["MRP"],
						data[i][j]["PKM"],
						data[i][j]["Category"],
						data[i][j]["Sub Category"],
						data[i][j]["Good"],
						data[i][j]["Expired"],
						data[i][j]["Damaged"],
						data[i][j]["Frozen"],
						data[i][j]["SAP TTL"],
						data[i][j]["MRP TTL"],
						data[i][j]["Good-WMS"],
						data[i][j]["Expired-WMS"],
						data[i][j]["Damaged-WMS"],
						data[i][j]["WMS TTL"],
						data[i][j]["MRP TTL"],
						data[i][j]["Diff QTY TTL (WMS - SAP)"],
						data[i][j]["Diff Value (WMS - SAP)"]
					]
				}else if(i == 1){
					var tmp_data = [
						data[i][j]["CBUCode"],
						data[i][j]["MRP"],
						data[i][j]["Category"],
						data[i][j]["Sub Category"],
						data[i][j]["Good"],
						data[i][j]["Expired"],
						data[i][j]["Damaged"],
						data[i][j]["Frozen"],
						data[i][j]["SAP TTL"],
						data[i][j]["MRP TTL"],
						data[i][j]["Good-WMS"],
						data[i][j]["Expired-WMS"],
						data[i][j]["Damaged-WMS"],
						data[i][j]["WMS TTL"],
						data[i][j]["MRP TTL"],
						data[i][j]["Diff QTY TTL (WMS - SAP)"],
						data[i][j]["Diff Value (WMS - SAP)"]
					]
				}else if(i == 2){
					var tmp_data = [
						data[i][j]["CBUCode"],
						data[i][j]["Category"],
						data[i][j]["Sub Category"],
						data[i][j]["Good"],
						data[i][j]["Expired"],
						data[i][j]["Damaged"],
						data[i][j]["Frozen"],
						data[i][j]["SAP TTL"],
						data[i][j]["Good-WMS"],
						data[i][j]["Expired-WMS"],
						data[i][j]["Damaged-WMS"],
						data[i][j]["WMS TTL"],
					]
				}
				
				if(i == 0){
					sheetIndex = 2;
				}else if(i == 2){
					sheetIndex = 0;
				}
				sheet_data[sheetIndex].push(tmp_data);
			}
			this.setState({
				different_workbook : sheet_data
			});
		 }
		 fileName = fileName.replace(".xlsx","");
         this.setState({ postsProductLedger: data })
         exportToMultiWBCSV(this.state.different_workbook, fileName)
      })

      .then(async() => {

         this.setState({ isLoading:false, genloading: false })

         

      });



  }

  




  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.postsProduct});
    } else {
      
      var value = this.state.postsProduct.filter(
        (val) =>{
        return Object.keys(val).some(key =>{
          var data = ""
          if (val[key] == null ) {
            data = ""
          } 
          else {
            data = val[key]
          }
          
          return data.toString().toLowerCase().includes(evt.toLowerCase()) 
        })
        }
         

      );

      this.setState({
        filtered_orderData: value,
      });
    }
  };
  filterData1 = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.postsBinInventory});
    } else {
      
      var value = this.state.postsBinInventory.filter(
        (val) =>{
        return Object.keys(val).some(key =>{
          var data = ""
          if (val[key] == null ) {
            data = ""
          } 
          else {
            data = val[key]
          }
          
          return data.toString().toLowerCase().includes(evt.toLowerCase()) 
        })
        }
        );

        this.setState({
          filtered_orderData: value,
        });
      }
    };
    filterData2 = (evt) => {
      if (evt == "") {
        this.setState({ filtered_orderData : this.state.postsTesterInventory});
      } else {
        
        var value = this.state.postsTesterInventory.filter(
          (val) =>{
          return Object.keys(val).some(key =>{
            var data = ""
            if (val[key] == null ) {
              data = ""
            } 
            else {
              data = val[key]
            }
            
            return data.toString().toLowerCase().includes(evt.toLowerCase()) 
          })
          }
          );
  
          this.setState({
            filtered_orderData: value,
          });
        }
      };
      filterData3 = (evt) => {
        if (evt == "") {
          this.setState({ filtered_orderData: this.state.postsNonMoving});
        } else {
          
          var value = this.state.postsNonMoving.filter(
            (val) =>{
            return Object.keys(val).some(key =>{
              var data = ""
              if (val[key] == null ) {
                data = ""
              } 
              else {
                data = val[key]
              }
              
              return data.toString().toLowerCase().includes(evt.toLowerCase()) 
            })
            }
            );
    
            this.setState({
              filtered_orderData: value,
            });
          }
        };
  assemblePostsProduct= () => {

    

    let postsProducts =this.state.postsProduct.map((post) => {

      return (

        {

          
          client: post.client,
          ib_sku_id: post.lb_sku_id,
          lb_sku_product_name: post.lb_sku_product_name,
          pkd: post.pkd,
          upc: post.upc,
          mrp: post.mrp,
          sku7Code: post.sku7_code,
          putaway_statging_qty: post.putaway_staging,
          receiving_staging: post.receiving_staging,
          bin_qty : post.bin_qty,
          pre_alloc_qty: post.PickingAllocation,
          wh_damaged : post.wh_damage_bin_qty,
          wh_expired : post.wh_expired_bin_qty,
          mkt_damaged : post.mkt_damaged,
          mkt_expired : post.mkt_expired,
          z_missing: post.z_missing ,  
		      z_excess : post.z_excess,

        }

      )

    });

    this.setState({
      postsProduct : postsProducts,
      filtered_orderData : postsProducts,
    });
    return postsProducts;

  }


  handleChange(evt) {
    const files = evt.target.files;
    if (files && files[0]) this.setState({ file: files[0] });
    var file1 = evt.target.value
    var fileArray1 = evt.target.value.split('.')
    var extension1 = fileArray1[fileArray1.length - 1]
    if(extension1 != 'xlsx' && extension1 != 'csv' && extension1 != 'xls'){
    
      $(".upload_error").css('display', 'block');
      $(".upload_success").css('display', 'none');
    }else {
      $(".upload_success").css('display', 'block');
      $(".upload_error").css('display', 'none');
      $('.button_enable').removeAttr('disabled','disabled');
    }
  };

  change = (selectedOption) => {
	let today_date = new Date();
	let date = today_date.getDate();
	let month = today_date.getMonth() + 1;
	let year = today_date.getFullYear();
	
	if(parseInt(month.toString().length) == 1){
		month= "0" + month.toString();
	}
	
	let today = year+"-"+month+"-"+date;
	let filename = selectedOption.label+"_"+today;
    this.setState({ selectedOption,
                  selectedFileType:selectedOption.label,
                  showInvalidProductItem: false,
                  showRowDataErrorProduct: false,
                  showInvalidBaseItem: false,
                  showRowDataErrorBase: false,
                  showRowDataError: false,
                  showInvalidItem: false,
                  showLocationInput: false,
				  fileNameVal : filename, 

     });
      $(".upload_error").css('display', 'none');
      $(".upload_success").css('display', 'none');
      $(".fileControl").val('');

      if (selectedOption.value === "9") {
		
        this.setState({
          showUpload: true,
          showGenerate: false,
          showInputUpload: true,
          showCustomerInventoryVSWmsInventory: true,
		  
		   showFetchBaseData: false,
        showFetchBinData: false,
        showFetchProductData: false,
        showinventoryaltData: false,
        showBinInventoryData: false,
        showFetchTesterPick: false,
        showBinTesterInventory: false,
        showTesterInventory: false,
        showBinUtilization: false,
        showLocationLedger: false,
        showProductLedger: false,
        showZoneCompliance: false,
        showNonMoving: false,
        showBinFragmentation: false,
        genloading: false
        })
        this.fetchCustomerInventoryVsWms();

      }else{

        this.setState({
          showUpload: false,
          showGenerate: true,
          showInputUpload: false,
          showCustomerInventoryVSWmsInventory: false
        })
      }

      if (selectedOption.value=== "3") {
        this.setState({
          showLocationInput: true
        })
      }


      if (selectedOption.value === "bin_master") {
          this.fetchBinData();
          this.setState({
            showFetchBinData: true,
            showFetchBaseData: false,
            showFetchProductData: false
          })

      } else if (selectedOption.value === "base_pack_zone") {
          this.fetchBaseData();
          this.setState({
            showFetchBinData: false,
            showFetchBaseData: true,
            showFetchProductData: false
          })

      } else if (selectedOption.value === "product_master") {
          this.fetchProductData();
          this.setState({
            showFetchBinData: false,
            showFetchBaseData: false,
            showFetchProductData: true
          })

      }
	  
	 if(selectedOption.value === "picking_not_confirmed"){
		this.setState({
			showDateFilter : true,
		});
	 }else{
		this.setState({
			showDateFilter : false,
		});
     }
	 if(selectedOption.value === "4"){
         window.location.href="/productIT/productLedger"
      }

  }
  

  validateItem = item => {
    const { selectedFileType, validation } = this.state
    const dataTypes = validation[selectedFileType]
    const keyNames = Object.keys(dataTypes)
    if(Object.keys(item).length !== keyNames.length){
      this.setState({
        error: "Invalid length of uploaded data. Below data are invalid. Please Upload a valid file format"
      })
      return false
    }
    /*if(Object.keys(item).filter(key => (keyNames.indexOf(key) === -1)).length){
      this.setState({
        error: "Invalid header of data uploaded. Below data are invalid. Please Upload a valid file formate"
      })
      return false
    }
    if(Object.keys(item).filter(key => (typeof item[key] !== dataTypes[key])).length){
      this.setState({
        error: "Invalid datatype of data uploaded.Below data are invalid. Please Upload a valid file formate"
      })
      return false
    }*/
    return true
  }


  generateReport1(){

    

    if (this.state.selectedOption.value==="picking_not_confirmed") {

      this.setState({
        showFetchBaseData: true,
        showFetchBinData: false,
        showFetchProductData: false,
        showinventoryaltData: false,
        showBinInventoryData: false,
        showBinTesterInventory: false,
        showFetchTesterPick: false,
        genloading: true

      })

	  
		var ledger_fromdate = "";
		var ledger_todate = ""
		if(this.state.ledger_fromdate != "" && this.state.ledger_fromdate != undefined){
			ledger_fromdate = formatDate(this.state.ledger_fromdate);  
		}
		if(this.state.ledger_todate != "" && this.state.ledger_todate != undefined){
		   ledger_todate = formatDate(this.state.ledger_todate);
		}
	  
      const payload = {
        location: this.state.selectedLocation,
			  from_date: ledger_fromdate,
              to_date: ledger_todate
  };

API.post('/reports/pickingNotConfirmed/v1/', { param: payload })

      .then(response => response.data)

      .then(data => {

        

         this.setState({ postsBase: data, loading: false })

      })

      .then(async() => {

         this.setState({ tableRowsBase:this.assemblePostsBase(), isLoading:false, genloading: false })


      });

            


         
          }



          if (this.state.selectedOption.value==="bin_available") {


      this.setState({
        showFetchBaseData: false,
        showFetchBinData: true,
        showFetchProductData: false,
        showFetchTesterPick: false,
        showinventoryaltData: false,
        showBinInventoryData: false,
        showBinTesterInventory: false,
        showTesterInventory: false,
        showBinUtilization: false,
        showLocationLedger: false,
        showProductLedger: false,
        showZoneCompliance: false,
        showNonMoving: false,
        showBinFragmentation: false,

        genloading: true

      })


      const payload = {
        location: this.state.selectedLocation,
  };

API.post('/reports/binAvailReport/v1/', { param: payload })

      .then(response => response.data)

      .then(data => {



         this.setState({ posts: data })

      })

      .then(async() => {

         this.setState({ tableRows:this.assemblePosts(), isLoading:false, genloading: false })


      });

            


         
          }


    if (this.state.selectedOption.value==="current_inventory") {
      this.setState({
        showFetchBaseData: false,
        showFetchBinData: false,
        showFetchProductData: true,
        showinventoryaltData: false,
        showBinInventoryData: false,
        showFetchTesterPick: false,
        showBinTesterInventory: false,
        showTesterInventory: false,
        showBinUtilization: false,
        showLocationLedger: false,
        showProductLedger: false,
        showZoneCompliance: false,
        showNonMoving: false,
        showBinFragmentation: false,
        genloading: true
      })


      const payload = {
        location: this.state.selectedLocation,
        inventoryType: 1
  };

API.post('/reports/currentInventoryReport/v1/', { param: payload })

      .then(response => response.data)

      .then(data => {

         this.setState({ postsProduct: data })
         

      })

      .then(async() => {

         this.setState({ tableRowsProduct:this.assemblePostsProduct(), isLoading:false, genloading: false })

        

      });
            


         
          }





      if (this.state.selectedOption.value==="current_inventory_alt_view") {


      this.setState({
        showFetchBaseData: false,
        showFetchBinData: false,
        showFetchProductData: false,
        showinventoryaltData: true,
        showBinInventoryData: false,
        showFetchTesterPick: false,
        showBinTesterInventory: false,
        showTesterInventory: false,
        showBinUtilization: false,
        showLocationLedger: false,
        showProductLedger: false,
        showZoneCompliance: false,
        showNonMoving: false,
        showBinFragmentation: false,
        genloading: true

      })


      const payload = {
        location: this.state.selectedLocation,
        inventoryType: 2
  };

API.post('/reports/currentInventoryReport/v1/', { param: payload })

      .then(response => response.data)

      .then(data => {


         this.setState({ postsInventoryAlt: data })
         

      })

      .then(async() => {

         this.setState({ tableInventoryAlt:this.assemblePostsInventoryAlt(), isLoading:false, genloading: false })

        

      });
            


         
          }






      if (this.state.selectedOption.value==="tester_pick") {


      this.setState({
        showFetchBaseData: false,
        showFetchBinData: false,
        showFetchProductData: false,
        showinventoryaltData: false,
        showFetchTesterPick: true,
        showBinInventoryData: false,
        showBinTesterInventory: false,
        showTesterInventory: false,
        showBinUtilization: false,
        showLocationLedger: false,
        showProductLedger: false,
        showZoneCompliance: false,
        showNonMoving: false,
        showBinFragmentation: false,

        genloading: true

      })


      const payload = {
           
        location: this.state.selectedLocation,
  };

API.post('/reports/testerPickReportTP/v1/', { param: payload })

      .then(response => response.data)

      .then(data => {

         this.setState({ postsTesterPick: data })
         

      })

      .then(async() => {

         this.setState({ tableTesterPick:this.assemblePostsTesterPick(), isLoading:false, genloading: false })


      });
            


         
          }


          if (this.state.selectedOption.value==="1" /*|| this.state.selectedOption.value==="2" || this.state.selectedOption.value==="3" || this.state.selectedOption.value==="4" || this.state.selectedOption.value==="5" || this.state.selectedOption.value==="6" || this.state.selectedOption.value==="7"*/ ) {


      this.setState({
        showFetchBaseData: false,
        showFetchBinData: false,
        showFetchProductData: false,
        showinventoryaltData: false,
        showFetchTesterPick: false,
        showBinInventoryData: false,
        showBinTesterInventory: false,
        showTesterInventory: true,
        showBinUtilization: false,
        showLocationLedger: false,
        showProductLedger: false,
        showZoneCompliance: false,
        showNonMoving: false,
        showBinFragmentation: false,

        genloading: true

      })




      const payload = {
           
        location: this.state.selectedLocation,
        report_type: 1
  };

API.post('/reports/multiReport/v1/', { param: payload })

      .then(response => response.data)

      .then(data => {

         this.setState({ postsTesterInventory: data ,filtered_orderData : data })
         

      })

      .then(async() => {

         this.setState({ tableTesterInventory:this.assemblePostsTesterInventory(), isLoading:false, genloading: false })


      });
            


         
          }



           if (this.state.selectedOption.value==="2" /*|| this.state.selectedOption.value==="2" || this.state.selectedOption.value==="3" || this.state.selectedOption.value==="4" || this.state.selectedOption.value==="5" || this.state.selectedOption.value==="6" || this.state.selectedOption.value==="7"*/ ) {


      this.setState({
        showFetchBaseData: false,
        showFetchBinData: false,
        showFetchProductData: false,
        showinventoryaltData: false,
        showFetchTesterPick: false,
        showBinInventoryData: false,
        showBinTesterInventory: false,
        showTesterInventory: false,
        showBinUtilization: true,
        showLocationLedger: false,
        showProductLedger: false,
        showZoneCompliance: false,
        showNonMoving: false,
        showBinFragmentation: false,

        genloading: true

      })

      


      const payload = {
        location: this.state.selectedLocation,
        report_type: 2
  };

API.post('/reports/multiReport/v1/', { param: payload })

      .then(response => response.data)

      .then(data => {


         this.setState({ postsBinUtilization: data })
         

      })

      .then(async() => {

         this.setState({ tableBinUtilization:this.assemblePostsBinUtilization(), isLoading:false, genloading: false })

         

      });
            


         
          }


          if (this.state.selectedOption.value==="3" /*|| this.state.selectedOption.value==="2" || this.state.selectedOption.value==="3" || this.state.selectedOption.value==="4" || this.state.selectedOption.value==="5" || this.state.selectedOption.value==="6" || this.state.selectedOption.value==="7"*/ ) {


      this.setState({
        showFetchBaseData: false,
        showFetchBinData: false,
        showFetchProductData: false,
        showinventoryaltData: false,
        showFetchTesterPick: false,
        showBinInventoryData: false,
        showBinTesterInventory: false,
        showTesterInventory: false,
        showBinUtilization: false,
        showLocationLedger: true,
        showProductLedger: false,
        showZoneCompliance: false,
        showNonMoving: false,
        showBinFragmentation: false,

        genloading: true

      })

      


      const payload = {
          
        location: this.state.selectedLocation,
        report_type: 3,
        bin_address: localStorage.getItem('bin_address'),
  };

API.post('/reports/multiReport/v1/', { param: payload })

      .then(response => response.data)

      .then(data => {

         this.setState({ postsLocationLedger: data })
         

      })

      .then(async() => {

         this.setState({ tableLocationLedger:this.assemblePostsLocationLedger(), isLoading:false, genloading: false })

         

      });
            


         
          }




          if (this.state.selectedOption.value==="4" /*|| this.state.selectedOption.value==="2" || this.state.selectedOption.value==="3" || this.state.selectedOption.value==="4" || this.state.selectedOption.value==="5" || this.state.selectedOption.value==="6" || this.state.selectedOption.value==="7"*/ ) {
      this.setState({
		  
        showFetchBaseData: false,
        showFetchBinData: false,
        showFetchProductData: false,
        showinventoryaltData: false,
        showFetchTesterPick: false,
        showBinInventoryData: false,
        showBinTesterInventory: false,
        showTesterInventory: false,
        showBinUtilization: false,
        showLocationLedger: false,
        showProductLedger: true,
        showZoneCompliance: false,
        showNonMoving: false,
        showBinFragmentation: false,

        genloading: true

      })

      


      const payload = {
        location: this.state.selectedLocation,
        report_type: 4,
  };

API.post('/reports/multiReport/v1/', { param: payload })

      .then(response => response.data)

      .then(data => {

         this.setState({ postsProductLedger: data })
         

      })

      .then(async() => {

         this.setState({ tableProductLedger:this.assemblePostsProductLedger(), isLoading:false, genloading: false })

         

      });
            


         
          }



          if (this.state.selectedOption.value==="5" /*|| this.state.selectedOption.value==="2" || this.state.selectedOption.value==="3" || this.state.selectedOption.value==="4" || this.state.selectedOption.value==="5" || this.state.selectedOption.value==="6" || this.state.selectedOption.value==="7"*/ ) {


      this.setState({
        showFetchBaseData: false,
        showFetchBinData: false,
        showFetchProductData: false,
        showinventoryaltData: false,
        showFetchTesterPick: false,
        showBinInventoryData: false,
        showBinTesterInventory: false,
        showTesterInventory: false,
        showBinUtilization: false,
        showLocationLedger: false,
        showProductLedger: false,
        showZoneCompliance: true,
        showNonMoving: false,
        showBinFragmentation: false,

        genloading: true

      })

      


      const payload = {
           
        location: this.state.selectedLocation,
        report_type: 5
  };

API.post('/reports/multiReport/v1/', { param: payload })

      .then(response => response.data)

      .then(data => {

         this.setState({ postsZoneCompliance: data })
         

      })

      .then(async() => {

         this.setState({ tableZoneCompliance:this.assemblePostsZoneCompliance(), isLoading:false, genloading: false })

         

      });
            


         
          }




          if (this.state.selectedOption.value==="6" /*|| this.state.selectedOption.value==="2" || this.state.selectedOption.value==="3" || this.state.selectedOption.value==="4" || this.state.selectedOption.value==="5" || this.state.selectedOption.value==="6" || this.state.selectedOption.value==="7"*/ ) {


      this.setState({
        showFetchBaseData: false,
        showFetchBinData: false,
        showFetchProductData: false,
        showinventoryaltData: false,
        showFetchTesterPick: false,
        showBinInventoryData: false,
        showBinTesterInventory: false,
        showTesterInventory: false,
        showBinUtilization: false,
        showLocationLedger: false,
        showProductLedger: false,
        showZoneCompliance: false,
        showNonMoving: true,
        showBinFragmentation: false,

        genloading: true

      })

      


      const payload = {
        location: this.state.selectedLocation,
        report_type: 6
  };

API.post('/reports/multiReport/v1/', { param: payload })
      .then(response => response.data)

      .then(data => {

         this.setState({ postsNonMoving: data ,filtered_orderData: data})
         

      })

      .then(async() => {

         this.setState({ tableNonMoving:this.assemblePostsNonMoving(), isLoading:false, genloading: false })

         

      });
            


         
          }




          if (this.state.selectedOption.value==="7" /*|| this.state.selectedOption.value==="2" || this.state.selectedOption.value==="3" || this.state.selectedOption.value==="4" || this.state.selectedOption.value==="5" || this.state.selectedOption.value==="6" || this.state.selectedOption.value==="7"*/ ) {


      this.setState({
        showFetchBaseData: false,
        showFetchBinData: false,
        showFetchProductData: false,
        showinventoryaltData: false,
        showFetchTesterPick: false,
        showBinInventoryData: false,
        showBinTesterInventory: false,
        showTesterInventory: false,
        showBinUtilization: false,
        showLocationLedger: false,
        showProductLedger: false,
        showZoneCompliance: false,
        showNonMoving: false,
        showBinFragmentation: true,

        genloading: true

      })

      


      const payload = {
        location: this.state.selectedLocation,
        report_type: 7
  };

API.post('/reports/multiReport/v1/', { param: payload })

      .then(response => response.data)

      .then(data => {

         // console.log(data);

         // if (err) throw err;

         this.setState({ postsBinFragmentation: data })
         

      })

      .then(async() => {

         this.setState({ tableBinFragmentation:this.assemblePostsBinFragmentation(), isLoading:false, genloading: false })

         

      });
            


         
          }




           if (this.state.selectedOption.value==="8" /*|| this.state.selectedOption.value==="2" || this.state.selectedOption.value==="3" || this.state.selectedOption.value==="4" || this.state.selectedOption.value==="5" || this.state.selectedOption.value==="6" || this.state.selectedOption.value==="7"*/ ) {


      this.setState({
        showFetchBaseData: false,
        showFetchBinData: false,
        showFetchProductData: false,
        showinventoryaltData: false,
        showFetchTesterPick: false,
        showBinInventoryData: false,
        showBinTesterInventory: false,
        showTesterInventory: false,
        showBinUtilization: false,
        showLocationLedger: false,
        showProductLedger: false,
        showZoneCompliance: false,
        showNonMoving: false,
        showBinFragmentation: false,

        genloading: true

      })

      


      const payload = {
        location: this.state.selectedLocation,
        report_type: 8
  };

API.post('/reports/multiReport/v1/', { param: payload })

      .then(response => response.data)

      .then(data => {

         // console.log(data);

         // if (err) throw err;

         this.setState({ postsBinFragmentation: data, postsZoneCorrection: data })

         this.exportToCSV1(this.state.postsZoneCorrection, "zone_correction_report")
         

      })

      .then(async() => {

         this.setState({ tableBinFragmentation:this.assemblePostsBinFragmentation(), isLoading:false, genloading: false })

         

      });
            


         
          }




      if (this.state.selectedOption.value==="bin_wise_inventory_report") {


      this.setState({
        showFetchBaseData: false,
        showFetchBinData: false,
        showFetchProductData: false,
        showinventoryaltData: false,
        showFetchTesterPick: false,
        showBinInventoryData: true,
        showBinTesterInventory: false,
        showTesterInventory: false,
        showBinUtilization: false,
        showLocationLedger: false,
        showProductLedger: false,
        showZoneCompliance: false,
        showNonMoving: false,
        showBinFragmentation: false,
        genloading: true

      })


      const payload = {
        location: this.state.selectedLocation,
        inventoryType: 1
  };

API.post('/reports/binInventoryReport/v1/', { param: payload })

      .then(response => response.data)

      .then(data => {

         this.setState({ postsBinInventory: data , filtered_orderData : data})
         

      })

      .then(async() => {

         this.setState({ tableBinInventory:this.assemblePostsBinInventory(), isLoading:false, genloading: false })

         /*console.log(this.state.tableInventoryAlt);*/

      });
            


         
          }



      if (this.state.selectedOption.value==="bin_wise_tester_inventory_") {


      this.setState({
        showFetchBaseData: false,
        showFetchBinData: false,
        showFetchProductData: false,
        showinventoryaltData: false,
        showBinInventoryData: false,
        showFetchTesterPick: false,
        showBinTesterInventory: true,
        showTesterInventory: false,
        showBinUtilization: false,
        showLocationLedger: false,
        showProductLedger: false,
        showZoneCompliance: false,
        showNonMoving: false,
        showBinFragmentation: false,
        genloading: true

      })


      const payload = {
        location: this.state.selectedLocation,
        inventoryType: 2
  };

API.post('/reports/binInventoryReport/v1/', { param: payload })

      .then(response => response.data)

      .then(data => {

         // console.log(data);

         // if (err) throw err;

         this.setState({ postsBinTesterInventory: data })
         

      })

      .then(async() => {

         this.setState({ tableBinTesterInventory:this.assemblePostsBinTesterInventory(), isLoading:false, genloading: false })

         /*console.log(this.state.tableInventoryAlt);*/

      });
                     
          }

  }

  processData(){

    this.setState({
      loading: true
    })


    if (this.state.selectedOption.value==="base_pack_zone") {

            

            console.log(this.state.data);
              var arr = []
    
          

          
          for(var i = 0; i < this.state.data.length; i++) {
               // <---- Move declaration inside loop
              
            var orderData  = {};
              orderData['basePackCode'] = this.state.data[i]['BasepackCode'];
              orderData['zoneName'] = this.state.data[i]['ZoneName'];
              orderData['zoneNo'] = this.state.data[i]['ZoneNo'];

              
              arr.push(orderData);
          }

          console.log(arr);
          var arr_data = JSON.stringify(arr)


          const payload = {
            arr_data: this.state.data,
            location:  this.state.selectedLocation,
            create: true,
  };

API.post('/inventory/base_pack_zone_code_master/v1/', { param: payload }) 
            .then((response) =>  {

              console.log(response);
              this.setState({
                showBaseResponseData: true,
                showInvalidBaseItem: false,
                showResponseData: false,
                showInvalidItem: false,
                showProductResponseData: false,
                showInvalidProductItem: false,
                showRowDataError: false,
                showRowDataErrorBase: false,
                showRowDataErrorProduct: false,
                modal: false,
                modalFailed: false,
                loading: false,
                responseFailBaseData: response.data,
                responseSuccessBaseData: response.data,
                successCreatedMessage: 'BasePack Successfully Created',
                Successmodal: true,


              })

              /*alert("BasePack Successfully Created");*/

              
              /*this.toggleFailed();*/
              this.fetchBaseData();

            })
            .catch(function (error) {
              
              
          });
          }


          if (this.state.selectedOption.value==="product_master") {




            console.log(this.state.data);
              var arr = []
    
          

          
          for(var i = 0; i < this.state.data.length; i++) {
               // <---- Move declaration inside loop
              
            var orderData  = {};
              orderData['company'] = this.state.data[i]['Company'];
              orderData['brand'] = this.state.data[i]['Brand'];
              orderData['subBrand'] = this.state.data[i]['Sub Brand'];
              orderData['lbSkuId'] = this.state.data[i]['LB SKU ID'];
              orderData['lbSkuProductName'] = this.state.data[i]['LB SKU Product Name'];
              orderData['basepackCode'] = this.state.data[i]['Basepack Code'];
              orderData['cbuCode'] = this.state.data[i]['CBU Code'];
              orderData['shadeCode'] = this.state.data[i]['Shade Code'];
              orderData['shadeName'] = this.state.data[i]['Shade Name'];
              orderData['category'] = this.state.data[i]['Category'];
              orderData['subCategory'] = this.state.data[i]['Sub-Category'];
              orderData['priceLot'] = this.state.data[i]['Price Lot'];
              orderData['mrp'] = this.state.data[i]['MRP'];
              orderData['uom'] = this.state.data[i]['UOM'];
              orderData['upc'] = this.state.data[i]['UPC'];
              orderData['packSize'] = this.state.data[i]['Pack Size'];
              orderData['packSizeUom'] = this.state.data[i]['Pack Size UOM'];
              orderData['ean'] = this.state.data[i]['EAN'];              
              orderData['icldEAN'] = this.state.data[i]['ICLD EAN'];
              orderData['weight'] = this.state.data[i]['Weight'];
              orderData['volume'] = this.state.data[i]['Volume'];
              orderData['icldVolume'] = this.state.data[i]['ICLD Volume'];
              orderData['sku7Code'] = this.state.data[i]['SKU7 Code'];
              orderData['sku5Code'] = this.state.data[i]['SKU5 Code'];
              orderData['offer'] = this.state.data[i]['Offer'];
              orderData['tester'] = this.state.data[i]['Tester'];
              orderData['storageType'] = this.state.data[i]['Storage Type'];
              orderData['status'] = this.state.data[i]['Status'];
              orderData['createdDateTime'] = this.state.data[i]['Created Date Time'];
              orderData['updatedDateTime'] = this.state.data[i]['Updated Date Time'];

              
              arr.push(orderData);
          }

          console.log(arr);
          var arr_data = JSON.stringify(arr)


          const payload = {
    
            arr_data: this.state.data,
            location:  this.state.selectedLocation,
            create: true
  };

API.post('/product/product_master/v1/', { param: payload })
            .then((response) =>  {

              console.log(response);
              this.setState({
                showBaseResponseData: false,
                loading: false,
                showProductResponseData: true,
                showInvalidBaseItem: false,
                showResponseData: false,
                showInvalidItem: false,
                showInvalidProductItem:false,
                showRowDataError: false,
                showRowDataErrorBase: false,
                showRowDataErrorProduct: false,
                modalFailed: false,
                modal: false,
                responseFailProductData: response.data,
                responseSuccessProductData: response.data,
                successCreatedMessage: 'Product Master Successfully Created',
                Successmodal: true,
                
              })
              /*alert("Product Master Successfully Created");*/
              /*this.toggle();*/
             /* this.toggleFailed();*/
              this.fetchProductData();

            })
            .catch(function (error) {
              
              
          });


              
          }


          if (this.state.selectedOption.value==="bin_master") {
              /*console.log(this.state.BinMasters.length);
              console.log(data.length);*/
            /*if (this.state.BinMasters.length != data.length) {
              alert("Invalid formate");
              let invalidItems = this.state.data.filter(item => !this.validateItem(item))
              console.log(invalidItems);
              return false;
            }*/

            

          var arr = []
    
          

          
          for(var i = 0; i < this.state.data.length; i++) {
               // <---- Move declaration inside loop
              
            var orderData  = {};
              orderData['storageType'] = this.state.data[i]['StorageType'];
              orderData['aisle'] = this.state.data[i]['Aisle'];
              orderData['rack'] = this.state.data[i]['Rack'];
              orderData['rackType'] = this.state.data[i]['RackType'];
              orderData['level'] = this.state.data[i]['Level'];
              orderData['binAddress'] = this.state.data[i]['BIN_ID'];
              orderData['binId'] = this.state.data[i]['Bin'];
              orderData['zoneName'] = this.state.data[i]['ZoneName'];
              orderData['zoneNo'] = this.state.data[i]['ZoneNo'];
              orderData['binVolume'] = 4;

              
              
              arr.push(orderData);
          }

          console.log(arr);
          var arr_data = JSON.stringify(arr)


          const payload = {
    
            arr_data: this.state.data,
            location:  this.state.selectedLocation,
            create: true
  };

API.post('/inventory/bin_master/v1/', { param: payload })
            .then((response) =>  {

              console.log(response);
              
              this.setState({
                showResponseData: true,
                showInvalidItem: false,
                loading: false,
                showBaseResponseData: false,
                showInvalidBaseItem: false,
                showInvalidProductItem: false,
                showProductResponseData: false,
                showRowDataError: false,
                showRowDataErrorBase: false,
                showRowDataError: false,
                modalFailed: false,
                modal: false,
                responseFailBinData: response.data,
                responseSuccessBinData: response.data,
                successCreatedMessage: 'Bin Master Successfully Created',
                Successmodal: true,

              })
             /* this.toggle();*/
              
              /*this.toggleFailed();*/
              /*alert("Bin Master Successfully Created");*/
              this.fetchBinData();

            })
            .catch(function (error) {
              
              
          });

          }


         /* this.toggleFailed();*/


  }


 

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    console.log(this.state.showInvalidItem)
    const { selectedOption } = this.state;
    const { modal } = this.state;
    const { modalFailed } = this.state;
    const { Successmodal } = this.state;


    const data = {

      columns: [

        {

          label:'Bin Address',

          field:'bin_address',
          sort: 'asc',
          width: 150

        },

        
        {

          label:'Zone No.',

          field:'zone_no',
          sort: 'asc',
          width: 150

        },


        {

          label:'Zone Name',

          field:'zone_name',
          sort: 'asc',
          width: 150

        },

        
        {

          label:'Ware House',

          field:'warehouse',
          sort: 'asc',
          width: 150

        },

      ],

      rows:this.state.tableRows,

    }


    const inventoryAltData = {

      columns: [

        {

          label:'Jarvis Product Id',

          field:'lb_sku_id',
          sort: 'asc',
          width: 150

        },

        {

          label:'Bin Address',

          field:'bin_address',
          sort: 'asc',
          width: 150

        },

        


        {

          label:'CBU Code',

          field:'cbu_code',
          sort: 'asc',
          width: 150

        },

        {

          label:'Bin Qty',

          field:'bin_qty',
          sort: 'asc',
          width: 150

        },

        {

          label:'sku7Code',

          field:'sku7_code',
          sort: 'asc',
          width: 150

        },

        {

          label:'MRP',

          field:'mrp',
          sort: 'asc',
          width: 150

        },

        {

          label:'PKD',

          field:'pkd',
          sort: 'asc',
          width: 150

        },

        {

          label:'EAN',

          field:'ean',
          sort: 'asc',
          width: 150

        },

      ],

      rows:this.state.tableInventoryAlt,

    }




    const binInventoryData = {

      columns: [

        

        {

          label:'Brand',

          field:'client',
          width: 110,
          sort: 'asc',

        },
        

        {

          label:'Jarvis Product Id',

          field:'lb_sku_id',
          width: 150,
          sort: 'asc',

        },

        {

          label:'Bin Status',

          field:'bin_status',
          width: 150,
          sort: 'asc',

        },

         {

          label:'Stock Type',

          field:'stock_type',
          width: 120,
          sort: 'asc',

        },


        {

          label:' Product Name',

          field:'lbSkuProductName',
          width: 190,
          sort: 'asc',

        },

        {

          label:'Basepack Code',

          field:'base_pack',
          width: 300,
          sort: 'asc',

        },

        {

          label:'PKD',

          field:'pkd',
          width: 150,
          sort: 'asc',

        },
        {

          label:'UPC',

          field:'upc',
          width: 150,
          sort: 'asc',

        },
		{

          label:'MRP',

          field:'mrp',
          width: 150,
          sort: 'asc',

        },
		
        {

          label:'CBU Code',

          field:'cbu_code',
          width: 150,
          sort: 'asc',

        },

        {

          label:'SKU7Code',

          field:'sku7_code',
          width: 150,
          sort: 'asc',

        },

        {

          label:'Bin Address',

          field:'bin_address',
          width: 150,
          sort: 'asc',

        },
        {

          label:'Zone Name',

          field:'zone_name',
          width: 150,
          sort: 'asc',

        },



        
        {

          label:'Quantity (pcs)',

          field:'quantity',
          width: 150,
          sort: 'asc',

        },

        {

          label:'Pre Alloc Qty (pcs)',

          field:'pre_alloc_qty',
          width: 150,
          sort: 'asc',

        },

         {

          label:'Putaway Alloc',

          field:'putaway_alloc',
          width: 150,
          sort: 'asc',

        },

        




      ],

      rows:this.state.tableBinInventory,

    }


    const testerInventoryData = {

      columns: [

        

        

        {

          label:'Basepack Code',

          field:'product__base_pack_code',
          sort: 'asc',
          width: 180

        },

        /*{

          label:'Product Tester',

          field:'product__tester',
          sort: 'asc',
          width: 180

        },*/


        {

          label:'Bin Quantity',

          field:'bin_qty',
          sort: 'asc',
          width: 100

        },

        {

          label:'PTL Staging Qty(Pcs)',

          field:'ptl_staging',
          sort: 'asc',
          width: 100

        },

        {

          label:'Putaway Staging Qty(Pcs)',

          field:'putaway_staging',
          sort: 'asc',
          width: 180

        },

        {

          label:'Dispatch Staging',

          field:'dispatch_staging',
          sort: 'asc',
          width: 100

        },

       

        

        {

          label:'Z_Missing',

          field:'z_missing',
          sort: 'asc',
          width: 100

        },

        {

          label:'Z Damaged',

          field:'z_damaged',
          sort: 'asc',
          width: 100

        },

        {

          label:'Z Excess',

          field:'z_excess',
          sort: 'asc',
          width: 100

        },

        {

          label:'Z Return',

          field:'z_return',
          width: 100

        },

        {

          label:'Z Expiry',

          field:'z_expiry',
          sort: 'asc',
          width: 100

        },

        {

          label:'Shortage  (Primary Pure)',

          field:'shortage_primary_pure',
          sort: 'asc',
          width: 180

        },

        {

          label:'Shortage  (Primary Interchange)',

          field:'shortage_primary_interchange',
          sort: 'asc',
          width: 180

        },

        {

          label:'Shortage Returns',

          field:'shortage_return',
          sort: 'asc',
          width: 120

        },

        {

          label:'Shortage Wh',

          field:'shortage_wh',
          sort: 'asc',
          width: 100

        },

        {

          label:'Excess (Primary Pure)',

          field:'excess_primary_pure',
          sort: 'asc',
          width: 150

        },

        {

          label:'Excess  (Primary Interchange)',

          field:'excess_primary_interchange',
          sort: 'asc',
          width: 180

        },

        {

          label:'Excess Returns',

          field:'excess_return',
          sort: 'asc',
          width: 120

        },

        {

          label:'Damaged Primary',

          field:'damaged_primary',
          sort: 'asc',
          width: 120

        },

        {

          label:'Damaged LeanBox',

          field:'damaged_leanbox',
          sort: 'asc',
          width: 120

        },




      ],

      rows:this.state.tableTesterInventory,

    }




    const binTesterInventoryData = {

      columns: [

        

        

        {

          label:'BasepackCode',

          field:'base_pack_code',
          sort: 'asc',
          width: 150,


        },


        {

          label:'Bin Address',

          field:'bin_address',
          sort: 'asc',
          width: 150

        },

        {

          label:'Quantity (pcs)',

          field:'quantity',
          sort: 'asc',
          width: 100

        },

        {

          label:'Pre Alloc Quantity (pcs)',

          field:'pre_alloc_qty',
          sort: 'asc',
          width: 100

        },

        
        




      ],

      rows:this.state.tableBinTesterInventory,

    }


     const testerPickData = {

      columns: [

        

        

        {

          label:'Tester Order No.',

          field:'tester_order_number',
          sort: 'asc',
          width: 150

        },


        {

          label:'Party Code',

          field:'party_code',
          sort: 'asc',
          width: 150

        },

        {

          label:'Party Name',

          field:'party_name',
          sort: 'asc',
          width: 100

        },

        {

          label:'Sales Beat',

          field:'sales_beat',
          sort: 'asc',
          width: 100

        },

        {

          label:'Shade Code',

          field:'shade_code',
          sort: 'asc',
          width: 100

        },

        {

          label:'Shade Name',

          field:'shade_name',
          sort: 'asc',
          width: 100

        },

        {

          label:'Product Description',

          field:'product_desc',
          sort: 'asc',
          width: 150

        },

        {

          label:'Picking Request Id',

          field:'picking_request_id',
          sort: 'asc',
          width: 100

        },

        {

          label:'Order Date',

          field:'orderdate',
          sort: 'asc',
          width: 100

        },

        {

          label:'PTL Id',

          field:'ptl_id',
          sort: 'asc',
          width: 100

        },

        {

          label:'zone',

          field:'zone',
          sort: 'asc',
          width: 100

        },

        {

          label:'BasePack Code',

          field:'base_pack_code',
          sort: 'asc',
          width: 100

        },

        {

          label:'Order Qty (pcs)',

          field:'order_qty',
          sort: 'asc',
          width: 100

        },

        {

          label:'Picked Qty (pcs)',

          field:'picked_qty',
          sort: 'asc',
          width: 100

        },

        
        




      ],

      rows:this.state.tableTesterPick,

    }


    const binUtilizationData = {

      columns: [

        

        

        {

          label:'Zone Id',

          field:'zone_id',
          sort: 'asc',
          width: 80

        },


        {

          label:'Zone Name',

          field:'zone_name',
          sort: 'asc',
          width: 180

        },

        {

          label:'Total',

          field:'Total',
          sort: 'asc',
          width: 100

        },

        {

          label:'Used',

          field:'Used',
          sort: 'asc',
          width: 100

        },

        {

          label:'Remaining',

          field:'Remaining',
          sort: 'asc',
          width: 100

        },

        {

          label:'BinUtilization(%)',

          field:'BinUtilization',
          sort: 'asc',
          width: 100

        },

        {

          label:'SpaceAvailable(%)',

          field:'SpaceAvailable',
          sort: 'asc',
          width: 100

        },

        




      ],

      rows:this.state.tableBinUtilization,

    }



    const locationLedgerData = {

      columns: [

        

        

        {

          label:'Status',

          field:'status',
          sort: 'asc',
          width: 80

        },


        {

          label:'From Pre Move Count',

          field:'from_pre_move_count',
          sort: 'asc',
          width: 150

        },

        {

          label:'From Area',

          field:'from_area',
          sort: 'asc',
          width: 100

        },

        {

          label:'To Area',

          field:'to_area',
          sort: 'asc',
          width: 100

        },

        {

          label:'From Post Move Count',

          field:'from_post_move_count',
          sort: 'asc',
          width: 150

        },

        

        




      ],

      rows:this.state.tableLocationLedger,

    }



    const productLedgerData = {

      columns: [

        

        

        {

          label:'Operation Date',

          field:'Operation_Date',
          sort: 'asc',
          width: 250

        },


        {

          label:'Operation',

          field:'Operation',
          sort: 'asc',
          width: 150

        },

        {

          label:'Operation ID',

          field:'Operation_ID',
          sort: 'asc',
          width: 150

        },

        {

          label:'Basepack Code',

          field:'Basepack_Code',
          sort: 'asc',
          width: 160

        },

        {

          label:'CBU Code',

          field:'CBU_Code',
          sort: 'asc',
          width: 120

        },

        {

          label:'Product ID',

          field:'Product_ID',
          sort: 'asc',
          width: 200

        },

        {

          label:'Product Name',

          field:'Product_Name',
          sort: 'asc',
          width: 280

        },

        {

          label:'PKD',

          field:'pkd',
          sort: 'asc',
          width: 120

        },

        {

          label:'QTY',

          field:'qty',
          sort: 'asc',
          width: 100

        },

        {

          label:'From Area',

          field:'From_Area',
          sort: 'asc',
          width: 150

        },

        {

          label:'To Area',

          field:'To_Area',
          sort: 'asc',
          width: 150

        },

        {

          label:'Username',

          field:'username',
          sort: 'asc',
          width: 150

        },

        




      ],

      rows:this.state.tableProductLedger,

    }




    const zoneComplianceData = {

      columns: [

        

        

        {

          label:'Zone No',

          field:'Zone_No',
          sort: 'asc',
          width: 150

        },


        {

          label:'Zone Name',

          field:'Zone_Name',
          sort: 'asc',
          width: 220

        },

        {

          label:'Bin Count',

          field:'Bin_Count',
          sort: 'asc',
          width: 150

        },

        {

          label:'Bins Occupied',

          field:'Bins_Occupied',
          sort: 'asc',
          width: 150

        },

        {

          label:'Bin Occupied by Correct Product',

          field:'Bin_Occupied_by_Correct_Product',
          sort: 'asc',
          width: 250

        },

        {

          label:'Bin Occupied by Product with Different Zone',

          field:'Bin_Occupied_by_Product_with_Different_Zone',
          sort: 'asc',
          width: 280

        },

        {

          label:'Bin Unoccupied',

          field:'Bin_Unoccupied',
          sort: 'asc',
          width: 280

        },

        




      ],

      rows:this.state.tableZoneCompliance,

    }



    const nonMovingData = {

      columns: [

        

        

        {

          label:'Base Pack',

          field:'Base_Pack',
          sort: 'asc',
          width: 180

        },


        {

          label:'In Stock(days)',

          field:'In_Stock',
          sort: 'asc',
          width: 200

        },

        {

          label:'Days Since Last Order',

          field:'Days_Since_Last_Order',
          sort: 'asc',
          width: 250

        },

       
        




      ],

      rows:this.state.tableNonMoving,

    }


    const binFragmentationData = {

      columns: [

        

        

        {

          label:'Product ID',

          field:'Product_ID',
          sort: 'asc',
          width: 250

        },


        {

          label:'Product Name',

          field:'Product_Name',
          sort: 'asc',
          width: 150

        },

        {

          label:'PKD',

          field:'PKD',
          sort: 'asc',
          width: 150

        },

        {

          label:'Total QTY',

          field:'Total_QTY',
          sort: 'asc',
          width: 150

        },

        {

          label:'Bin MAX QTY',

          field:'Bin_MAX_QTY',
          sort: 'asc',
          width: 120

        },

        {

          label:'Bin Count',

          field:'Bin_Count',
          sort: 'asc',
          width: 200

        },

        

        

        




      ],

      rows:this.state.tableBinFragmentation,

    }



   




    const baseData = {

      columns: [

        {

          label:'Sl No.',

          field:'sl_no',
          sort: 'asc',
          width: 100

        },

        {

          label:'PTL ID',

          field:'ptl_id',
          sort: 'asc',
          width: 100

        },

        {

          label:'CBU Code',

          field:'cbu_code',
          sort: 'asc',
          width: 100

        },

        {

          label:'Batch',

          field:'batch',
          sort: 'asc',
          width: 100

        },

        {

          label:'Jarvis Product ID',

          field:'lbSkuId',
          sort: 'asc',
          width: 150

        },


        {

          label:'Product Name',

          field:'lbSkuProductName',
          sort: 'asc',
          width: 180

        },

        {

          label:'MRP',

          field:'mrp',
          sort: 'asc',
          width: 100

        },

        {

          label:'UPC',

          field:'upc',
          sort: 'asc',
          width: 100

        },

        {

          label:'PKD',

          field:'pkd',
          sort: 'asc',
          width: 100

        },

        {

          label:'Total Quantity (pcs)',

          field:'total_quantity',
          sort: 'asc',
          width: 100

        },

        {

          label:'ICLD Quantity (Box)',

          field:'icld_quantity (pcs)',
          sort: 'asc',
          width: 100

        },

        {

          label:'Loose Quantity (pcs)',

          field:'loose_quantity',
          sort: 'asc',
          width: 100

        },

        {

          label:'BasePack Code',

          field:'base_pack_code',
          sort: 'asc',
          width: 160
        },

        {

          label:'Added on',

          field:'added_on',
          sort: 'asc',
          width: 120
        },




      ],

      rows:this.state.tableRowsBase,

    }



    const productData = {

      columns: [

       {

          label:'Brand',

          field:'client',
          sort: 'asc',
          width: 110

        },
        {

          label:'Jarvis Product Id',

          field:'ib_sku_id',
          sort: 'asc',
          width: 180

        },

        {

          label:'Product Name',

          field:'lb_sku_product_name',
          sort: 'asc',
          width: 180

        },

        {

          label:'PKD',

          field:'pkd',
          sort: 'asc',
          width: 100

        },
        {

          label:'UPC',

          field:'upc',
          sort: 'asc',
          width: 100

        },

        {

          label:'MRP',

          field:'mrp',
          sort: 'asc',
          width: 100

        },

        
        {

          label:'Product Code',

          field:'sku7Code',
          sort: 'asc',
          width: 130

        },

        {

          label:'Putaway Staging Qty',

          field:'putaway_statging_qty',
          sort: 'asc',

          width: 160

        },

        {

          label:'Receiving Staging',

          field:'receiving_staging',
          sort: 'asc',

          width: 150

        },

        {

          label:'Available',

          field:'bin_qty',
          sort: 'asc',
          width: 100

        },

        {

          label:'Allocated',

          field:'pre_alloc_qty',
          sort: 'asc',
          width: 150

        },


        {

          label:'WH Damaged',

          field:'wh_damaged',
          sort: 'asc',
          width: 150

        },
        {

          label:'WH_EXPIRED',

          field:'wh_expired',
          sort: 'asc',
          width: 150

        },
        {

          label:'MKT_DAMAGED',

          field:'mkt_damaged',
          sort: 'asc',
          width: 150

        },
        {

          label:'MKT_EXPIRED',

          field:'mkt_expired',
          sort: 'asc',
          width: 150

        },

   

        {

          label:'Short',

          field:'z_missing',
          sort: 'asc',
          width: 100

        },

     
		
		{

          label:'Excess',

          field:'z_excess',
          sort: 'asc',
          width: 120

        },

      ],

      rows:this.state.tableRowsProduct,

    }

    const customerInventoryVSWmsData = {

      columns: [

        

        

        {

          label:'File name',

          field:'file_name',
          sort: 'asc',
          width: 220,


        },


        {

          label:'Status',

          field:'status',
          sort: 'asc',
          width: 150

        },

        {

          label:'Status Completion',

          field:'status_completion',
          sort: 'asc',
          width: 100

        },

        {

          label:'Download Excel',

          field:'download_excel',
          sort: 'asc',
          width: 100

        },

        




      ],

      rows:this.state.tableRowsCustomerVsWm,

    }







    return (
      <Col xl={12}>
        <Card style={{marginTop: 1}}>
          <CardBody style={{height: 70, marginTop: -20}}>
            
            <form className="form form--inline" onSubmit={handleSubmit}>
              
              <div className="form__form-group col-xl-4" style={{display: 'inline-flex'}}>
                
                <span className="form__form-group-label col-xl-5" style={{display: 'none', paddingTop: 6, paddingBottom: 6}} >Select Report Type</span>
                

                
                <div className="form__form-group-field col-xl-6" style={{display: 'contents'}}>
                 
                  <Field
                    name="select"
                    label="Select"
                    component={renderSelectField}
                    placeholder="Select Report"
                    value={selectedOption} 
                    onChange={this.change}                    
                    options={[
                      { value: 'current_inventory', label: 'Product Wise Inventory Report' },
                      { value: 'bin_wise_inventory_report', label: 'Location Wise Inventory Report' },
                      { value: '1', label: 'Tester Inventory Report' },
                      { value: '6', label: 'Non-Moving & Slow Moving Stock' }
                      
                    ]}
                  />

                
                </div>
                
                
              </div>
			  
			   
              { this.state.showLocationInput && (

                <div className="form__form-group col-xl-3">
                  <input type ="text" placeholder="Enter Bin Address" onChange= {(e)=>this.onBinChange(e.target.value )} style={{padding: 4, borderRadius: 2}} />

                </div>

              )}

              
            
            

              <div className="form__form-group col-xl-5" style={{display: 'none'}}>
               
                
                  <div className="col-xl-12">
                  <input  style={{paddingTop: 8,  height: 38}}
                    name="defaultInput"
                    component="input"
                    type="file"
                    placeholder="Default Input"
                    className="fileControl"
                    id="my_file_input" 
                    onChange={this.handleChange} 
                  />
                  </div>
                  <div className="col-xl-12">
                  <span style={{display: 'none' , color:'red'}} className="upload_error"> Invalid file format. Please select .xls, .xlsx, .csv file format </span>
                  <span style={{display: 'none' , color:'green', marginTop: 8}} className="upload_success"> Valid file format </span>
                  </div>
                
                
                
              </div>

               {this.state.showInputUpload && (

              <div className="form__form-group col-xl-3">
                <input type="file" name="file" onChange={this.setFile} />
              </div>

              )}
			  
			  
			  {this.state.showDateFilter && (
			  
			  <div className="form__form-group col-xl-2" style={{display: 'inline-block',width:'100%',marginBottom:'0px'}}>
                
					<DatePicker
                    selected={this.state.ledger_fromdate}
                    onChange={this.ledgerFromDateChange}
                    className="ledger_fromdate"
					placeholderText="From Date"
                    format='yyyy-MM-dd'
                  />
              </div>
			  
			  
			  )}
			  
			  {this.state.showDateFilter && (
			  <div className="form__form-group col-xl-2" style={{display: 'inline-block',width:'100%',marginBottom:'0px'}}>
				<DatePicker 
                    selected={this.state.ledger_todate}
                    onChange={this.ledgerToDateChange}
                    className="ledger_todate"
					placeholderText="To Date"
                  />
				
              </div>
			)}

              {this.state.showGenerate && (

              <div className="form__form-group col-xl-2">
                <ButtonToolbar className="form__button-toolbar">
                    <button color="primary" className="btn-sm button_enable " style={{fontWeight:'normal',textTransform:'capitalize',borderRadius: 5, backgroundColor:'#70bbfd', color:'#fff',padding: "5px 25px",fontSize: "14px"}} id="button_enable" onClick={this.generateReport1} >
                    {this.state.genloading && 
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    }

                    View
                    </button>
                </ButtonToolbar>
              </div>

              )}

			 

              {this.state.showUpload && (

              <div className="form__form-group col-xl-4">
                <ButtonToolbar className="form__button-toolbar">
                    <button color="primary" className="btn-sm button_enable " style={{borderRadius: 5, backgroundColor:'#70bbfd', color:'#fff'}} id="button_enable" onClick={this.uploadFile} >
                    {this.state.genloading && 
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    }

                    Upload
                    </button>
					<button color="primary" className="btn-sm button_enable " style={{borderRadius: 5, backgroundColor:'#70bbfd', color:'#fff'}} onClick={(e) => exportToCSV(this.state.download_sample_excel,"Sample_file")} >

                    Sample Template
                    </button>
                
                </ButtonToolbar>
              </div>

              )}
            
            </form>
          </CardBody>

          {
            this.state.showRowDataError  && (
                <CardBody style={{marginTop: 2}}>
                  <div>
                    <h4 style={{color: 'red', fontWeight: 'bold'}} className="subhead red-text"> Please upload file again. </h4>
                  </div>
                  <Table responsive className="table--bordered">
                    <thead>
                      <tr>
                        <th>BIN ID</th>
                        <th>Reason</th>
                        
                      </tr>
                    </thead>
                    <tbody>
                    {
                      this.state.ErrorRowData.length>0 && (
                      this.state.ErrorRowData.map((item, index) => (
                        <tr>
                          <td>{item['Bin']}</td>
                          <td style={{color:'red'}}> Column is missing </td>
                                           
                          
                        </tr>
                      )))
                    }


                    </tbody>
                  </Table>
                </CardBody>
            )
          }




          {
            this.state.showInvalidItem  && (
                <CardBody style={{marginTop: 20}}>
                  <div>
                  {this.state.show_process_data &&
                    <h4 style={{color: 'red', fontWeight: 'bold'}} className="subhead red-text">
                      <Button style={{backgroundColor: '#24d6a3', color: '#fff', marginLeft: 12}} className="modal_ok show_bin_proceed"  onClick={this.processData}>

                        {this.state.loading && 
                          <i
                            className="fa fa-refresh fa-spin"
                            style={{ marginRight: "5px" }}
                          />
                        }
                      Proceed</Button>
                     </h4>
                  }
                  </div>
                  <Table responsive className="table--bordered">
                    <thead>
                      <tr>
                        <th>BIN ID</th>
                        <th>Response</th>
                        
                        
                      </tr>
                    </thead>
                    <tbody>
                    {
                      this.state.responseFailBinData.failure_response.length>0 && (
                      this.state.responseFailBinData.failure_response.map((item, index) => (
                        <tr>
                          <td>{item.bin_address}</td>
                          <td style={{color: 'red'}}>{item.message}</td>
                          
                        </tr>
                      )))
                    }

                    {
                      this.state.responseSuccessBinData.success_response.length>0 && (
                      this.state.responseSuccessBinData.success_response.map((item, index) => (
                        <tr>
                          <td>{item.bin_address}</td>
                          <td style={{color: 'green'}}>{item.message}</td>
                          
                        </tr>
                      )))
                    }


                    </tbody>
                  </Table>
                </CardBody>
            )
          }

          {
            this.state.showFetchBinData  && (

          <CardBody style={{marginTop: 8}}>
            <div className="table_header">
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text">Bin Available Report</h4>
              <Button style={{marginBottom: 0, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" onClick={(e) => exportToCSV(this.state.posts, this.state.fileNameVal)}>Download Excel</Button>
            </div>
            <MDBDataTable
            striped
            bordered
            hover
            scrollX
			entries={7}
            data={data}
          />


          </CardBody>

          )}


          {
            this.state.showinventoryaltData  && (

          <CardBody style={{marginTop: 8}}>
            <div className="table_header">
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text">Current Inventory Alt View Report</h4>
              <Button style={{marginBottom: 0, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" onClick={(e) => exportToCSV(this.state.postsInventoryAlt, this.state.fileNameVal)}>Download Excel</Button>
            </div>
            <MDBDataTable
            striped
            bordered
            hover
            scrollX
			entries={7}
            data={inventoryAltData}
          />


          </CardBody>

          )}


          {
            this.state.showBinInventoryData  && (

          <CardBody style={{marginTop: 8}}>
            <div className="table_header" style={{borderBottomWidth:'0px'}}>
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text">Location Wise Inventory Report</h4>
			  <span
                    className="pull-right"
                    onClick={(e) => exportToCSV(this.state.filtered_orderData, this.state.fileNameVal, this.state.locaton_wise_header)}
                    style={{
                      fontSize: "17px",
                      paddingRight: "0px",
                      cursor: "pointer",
                      color: "#919193",
                      paddingTop: "9px",
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                  </span>
				  {/*<Button style={{marginBottom: 0, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" onClick={(e) => exportToCSV(this.state.postsBinInventory, this.state.fileNameVal)}>Download Excel</Button>*/}
            </div>
			<hr style={{marginTop:'30px',marginBottom:'0px'}}/>

            <MDBDataTable
            striped
            bordered
            hover
            scrollX
            onSearch={this.filterData1}
			entries={7}
            data={binInventoryData}
          />


          </CardBody>

          )}


          {
            this.state.showBinTesterInventory  && (

          <CardBody style={{marginTop: 8}}>
            <div className="table_header">
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text">Bin Wise Tester Inventory Report</h4>
              <Button style={{marginBottom: 0, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" onClick={(e) => exportToCSV(this.state.postsBinTesterInventory, this.state.fileNameVal)}>Download Excel</Button>
            </div>
            <MDBDataTable
            striped
            bordered
            hover
            scrollX
			entries={7}
            data={binTesterInventoryData}
            sorting={true}
          />


          </CardBody>

          )}



          {
            this.state.showRowDataErrorBase  && (
                <CardBody style={{marginTop: 20}}>
                  <div>
                    <h4 style={{color: 'red', fontWeight: 'bold'}} className="subhead red-text">Please upload file again </h4>
                  </div>
                  <Table responsive className="table--bordered">
                    <thead>
                      <tr>
                        <th>Base Pack Code</th>
                        <th>Reason</th>
                        
                      </tr>
                    </thead>
                    <tbody>
                    {
                      this.state.ErrorRowData.length>0 && (
                      this.state.ErrorRowData.map((item, index) => (
                        <tr>
                          <td>{item['Basepack Code']}</td>
                          <td style={{color:'red'}}> Column is missing </td>
                                           
                          
                        </tr>
                      )))
                    }


                    </tbody>
                  </Table>
                </CardBody>
            )
          }




          {
            this.state.showInvalidBaseItem  && (
                <CardBody style={{marginTop: 20}}>
                  <div>
                  {this.state.show_process_data &&
                    <h4 style={{color: 'red', fontWeight: 'bold'}} className="subhead red-text"> <Button style={{backgroundColor: '#24d6a3', color: '#fff', marginLeft: 12}} className="modal_ok"  onClick={this.processData}>
                      {this.state.loading && 
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    }

                    Proceed</Button> </h4>
                  }
                  </div>
                  <Table responsive className="table--bordered">
                    <thead>
                      <tr>
                        <th>Base Pack Code</th>
                        <th>Response</th>
                        
                        
                      </tr>
                    </thead>
                    <tbody>
                    {
                      this.state.responseFailBaseData.failure_response.length>0 && (
                      this.state.responseFailBaseData.failure_response.map((item, index) => (
                        <tr>
                          <td>{item.basePackCode}</td>
                          <td style={{color: 'red'}}>{item.message}</td>
                          
                        </tr>
                      )))
                    }

                    {
                      this.state.responseSuccessBaseData.success_response.length>0 && (
                      this.state.responseSuccessBaseData.success_response.map((item, index) => (
                        <tr>
                          <td>{item.basePackCode}</td>
                          <td style={{color: 'green'}}>{item.message}</td>
                          
                        </tr>
                      )))
                    }



                    </tbody>
                  </Table>
                </CardBody>
            )
          }

          {
            this.state.showFetchBaseData  && (

          <CardBody style={{marginTop: 8}}>
            <div className="table_header">
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text">Picking Not Confirmed Report</h4>
              <Button style={{marginBottom: 0, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" onClick={(e) => exportToCSV(this.state.postsBase, this.state.fileNameVal)}>Download Excel</Button>
            </div>
            <MDBDataTable
            striped
            bordered
            hover
            scrollX
			entries={7}
            data={baseData}
          />
          </CardBody>

          )}


          {
            this.state.showTesterInventory  && (

          <CardBody style={{marginTop: 8}}>
            <div className="table_header" style={{borderBottomWidth:'0px'}}>
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text">Tester Inventory Report</h4>
			  <span
                    className="pull-right"
                    onClick={(e) => exportToCSV(this.state.filtered_orderData, this.state.fileNameVal,this.state.tester_inventory_header)}
                    style={{
                      fontSize: "17px",
                      paddingRight: "0px",
                      cursor: "pointer",
                      color: "#919193",
                      paddingTop: "9px",
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                  </span>
				  {/*<Button style={{marginBottom: 0, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" onClick={(e) => exportToCSV(this.state.postsTesterInventory, this.state.fileNameVal)}>Download Excel</Button>*/}
            </div>
			<hr style={{marginTop:'30px',marginBottom:'0px'}}/>
            <MDBDataTable
            striped
            bordered
            hover
            scrollX
            onSearch={this.filterData2}
			entries={7}
            data={testerInventoryData}
          />
          </CardBody>

          )}


            {
            this.state.showBinUtilization  && (

          <CardBody style={{marginTop: 8}}>
            <div className="table_header">
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text">Bin Utilization Report</h4>
              <Button style={{marginBottom: 0, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" onClick={(e) => exportToCSV(this.state.postsBinUtilization, this.state.fileNameVal)}>Download Excel</Button>
            </div>
            <MDBDataTable
            scrollX
            striped
            bordered
            hover
            entries={7}
            data={binUtilizationData}
          />
          </CardBody>

          )}

           {
            this.state.showLocationLedger  && (

          <CardBody style={{marginTop: 8}}>
            <div className="table_header">
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text">Location Ledger Report</h4>
              <Button style={{marginBottom: 0, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" onClick={(e) => exportToCSV(this.state.postsLocationLedger, this.state.fileNameVal)}>Download Excel</Button>
            </div>
            <MDBDataTable
            scrollX
            striped
            bordered
            hover
            entries={7}
            data={locationLedgerData}
          />
          </CardBody>

          )}


            {
            this.state.showProductLedger  && (

          <CardBody style={{marginTop: 8}}>
            <div className="table_header">
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text">Product Ledger Report</h4>
              <Button style={{marginBottom: 0, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" onClick={(e) => exportToCSV(this.state.postsProductLedger, this.state.fileNameVal)}>Download Excel</Button>
            </div>
            <MDBDataTable
            scrollX
            striped
            bordered
            hover
            entries={7}
            data={productLedgerData}
          />
          </CardBody>

          )}


            {
            this.state.showZoneCompliance  && (

          <CardBody style={{marginTop: 8}}>
            <div className="table_header">
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text">Zone Compliance Report</h4>
              <Button style={{marginBottom: 0, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" onClick={(e) => exportToCSV(this.state.postsZoneCompliance, this.state.fileNameVal)}>Download Excel</Button>
            </div>
            <MDBDataTable
            scrollX
            striped
            bordered
            hover
            entries={7}
            data={zoneComplianceData}
          />
          </CardBody>

          )}

            {
            this.state.showNonMoving  && (

          <CardBody style={{marginTop: 8}}>
            <div className="table_header">
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text"> Non Moving And Slow Moving Stock</h4>
			  <span
                    className="pull-right"
                    onClick={(e) => exportToCSV(this.state.filtered_orderData, this.state.fileNameVal,this.state.nonmoving_header)}
                    style={{
                      fontSize: "17px",
                      paddingRight: "0px",
                      cursor: "pointer",
                      color: "#919193",
                      paddingTop: "9px",
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                  </span>
				  {/*<Button style={{marginBottom: 0, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" onClick={(e) => exportToCSV(this.state.postsNonMoving, this.state.fileNameVal)}>Download Excel</Button>*/}
            </div>
			<hr style={{marginTop:'30px',marginBottom:'0px'}}/>
            <MDBDataTable
            scrollX
            striped
            bordered
            onSearch={ this.filterData3}
            hover
            entries={7}
            data={nonMovingData}
          />
          </CardBody>

          )}

            {
            this.state.showBinFragmentation  && (

          <CardBody style={{marginTop: 20}}>
            <div className="table_header">
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text">Bin Fragmentation Report</h4>
              <Button style={{marginBottom: 0, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" onClick={(e) => exportToCSV(this.state.postsBinFragmentation, this.state.fileNameVal)}>Download Excel</Button>
            </div>
            <MDBDataTable
            scrollX
            striped
            bordered
            hover
            entries={7}
            data={binFragmentationData}
          />
          </CardBody>

          )}




          {
            this.state.showFetchTesterPick  && (

          <CardBody style={{marginTop: 20}}>
            <div className="table_header">
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text">Tester Pick</h4>
              <Button style={{marginBottom: 0, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" onClick={(e) => exportToCSV(this.state.postsTesterPick, this.state.fileNameVal)}>Download Excel</Button>
            </div>
            <MDBDataTable
            striped
            bordered
            hover
            scrollX
			entries={7}
            data={testerPickData}
          />
          </CardBody>

          )}


           {
            this.state.showCustomerInventoryVSWmsInventory  && (

          <CardBody style={{marginTop: 20}}>
            <div className="table_header">
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text">Customer Inventory VS WMS Inventory</h4>
              
            </div>
            <MDBDataTable
            striped
            bordered
            hover
            scrollX
			entries={7}
            data={customerInventoryVSWmsData}
          />


          </CardBody>

          )}



          {
            this.state.showRowDataErrorProduct  && (
                <CardBody style={{marginTop: 20}}>
                  <div>
                    <h4 style={{color: 'red', fontWeight: 'bold'}} className="subhead red-text"> Please upload file again </h4>
                  </div>
                  <Table responsive className="table--bordered">
                    <thead>
                      <tr>
                        <th>Jarvis Product ID</th>
                        <th>Reason</th>
                        
                      </tr>
                    </thead>
                    <tbody>
                    {
                      this.state.ErrorRowData.length>0 && (
                      this.state.ErrorRowData.map((item, index) => (
                        <tr>
                          <td>{item['jarvis Product ID']}</td>
                          <td style={{color:'red'}}> Column is missing </td>
                                           
                          
                        </tr>
                      )))
                    }


                    </tbody>
                  </Table>
                </CardBody>
            )
          }




          {
            this.state.showInvalidProductItem  && (
                <CardBody style={{marginTop: 20}}>
                  <div>
                  {this.state.show_process_data &&
                    <h4 style={{color: 'red', fontWeight: 'bold'}} className="subhead red-text">
                      <Button style={{backgroundColor: '#24d6a3', color: '#fff', marginLeft: 12}} className="modal_ok"  onClick={this.processData}>
                        {this.state.loading && 
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                      }
                      Proceed</Button> 
                     </h4>
                    }
                  </div>
                  <Table responsive className="table--bordered">
                    <thead>
                      <tr>
                        <th>Jarvis Product ID</th>
                        <th>Response</th>
                        
                        
                      </tr>
                    </thead>
                    <tbody>
                    {
                      this.state.responseFailProductData.failure_response.length>0 && (
                      this.state.responseFailProductData.failure_response.map((item, index) => (
                        <tr>
                          <td>{item.lb_sku_id}</td>
                          <td style={{color: 'red'}}>{item.message}</td>
                          
                        </tr>
                      )))
                    }

                    {
                      this.state.responseSuccessProductData.success_response.length>0 && (
                      this.state.responseSuccessProductData.success_response.map((item, index) => (
                        <tr>
                          <td>{item.lb_sku_id}</td>
                          <td style={{color: 'green'}}>{item.message}</td>
                          
                        </tr>
                      )))
                    }


                    </tbody>
                  </Table>
                </CardBody>
            )
          }

          {
            this.state.showFetchProductData  && (

          <CardBody style={{marginTop: 8}}>
            <div className="table_header" style={{borderBottomWidth:'0px'}}>
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text">Product Wise Inventory Report</h4>
			  <span
                    className="pull-right"
                    onClick={(e) => exportToCSV(this.state.filtered_orderData, this.state.fileNameVal,this.state.product_inventory_header)}
                    style={{
                      fontSize: "17px",
                      paddingRight: "0px",
                      cursor: "pointer",
                      color: "#919193",
                      paddingTop: "9px",
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                  </span>
				  {/*<Button style={{marginBottom: 0, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" onClick={(e) => exportToCSV(this.state.postsProduct, this.state.fileNameVal)}>Download Excel</Button>*/}
            </div>
			<hr style={{marginTop:'30px',marginBottom:'0px'}}/>
            <MDBDataTable
            striped
            bordered
            hover
            scrollX
            onSearch={this.filterData}
			entries={7}
            data={productData}
            // scrollX={true}
          />
          </CardBody>

          )}





        </Card>
        <Modal
          isOpen={modal}
          toggle={this.toggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.toggle} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-thumbs-up modal__title-icon" style={{color: '#4ce1b6'}} />
            <h4> {this.state.uploadMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.togglePressCancel}>Ok</Button>
          </ButtonToolbar>
        </Modal>


        <Modal
          isOpen={modalFailed}
          toggle={this.toggleFailed}

          style={{maxWidth: 578}}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.toggleFailed} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-cross-circle modal__title-icon" style={{color: 'red'}} />
            <h4>{this.state.uploadMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#ddd', color: '#fff'}} className="modal_ok"  onClick={this.togglePressCancel}>Cancel</Button>
            
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={Successmodal}
          toggle={this.Successtoggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.Successtoggle} />
           
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-thumbs-up modal__title-icon" style={{color: '#4ce1b6'}} />
            <h4>{this.state.successCreatedMessage}</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.SuccesstoggleCancel}>Ok</Button>
          </ButtonToolbar>
        </Modal>



      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));
